import { ISerologyTracking, SerologyTrackingListType } from '@nkr/models/index';
import { SerologyTrackingStatus } from '@nkr/enums/index';
import { AdminActions } from './models';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';

interface IProps {
    centerId: number,
    data: ISerologyTracking,
    listType: SerologyTrackingListType,
    onMenuDisplayed?: (id: number) => void,
    onMenuToggle: (show: boolean) => void,
    onItemSelected: (data: ISerologyTracking, action: number) => void
}

const menuItemList = [
    { action: AdminActions.MarkShipped, title: <>Mark Shipped</> },
    { action: AdminActions.MarkCancelled, title: <>Cancel Request</> },

    { action: AdminActions.TrackPackage, title: <>Track Package</> },
    { action: AdminActions.MarkReceived, title: <>Mark Received</> },
    { action: AdminActions.ShipToRemoteDonor, title: <>Ship to Remote Donor</> },
    { action: AdminActions.SerologyTestsShippedBack, title: <>Serology Tests Shipped Back</> },

    { action: AdminActions.ResultsSent, title: <>Results Sent</> },
    { action: AdminActions.Delete, title: <>Delete (NKR Only)</> },
    { action: AdminActions.Divider, title: <></> }
];

const ActionsDropdownAdmin = (props: IProps) => {
    const handleMenuToggle = (show: boolean) => {
        props.onMenuToggle(show);
    };

    const handleMenuSelection = (id: any, action: number) => {
        props.onItemSelected(props.data, action);
    };

    const getUrl = (action: AdminActions) => {
        let { status, remoteSendTrackingNumber, shipBackTrackingNumber, shipOutTrackingNumber } = props.data;

        switch (action) {
            case AdminActions.TrackPackage: return {
                link: "https://www.packagetrackr.com/track/" + (status == "Vendor Kit Shipped" ? shipOutTrackingNumber :
                    status == "Shipped to Remote Donor" ? remoteSendTrackingNumber :
                        shipBackTrackingNumber), target: '_blank'
            };
        }
    };

    const getMenuItems = () => {
        let menuItems: AdminActions[] = [];

        if (props.listType == SerologyTrackingListType.PendShipping) {
            menuItems.push(AdminActions.MarkShipped);
            menuItems.push(AdminActions.MarkCancelled);
        }

        if (props.listType == SerologyTrackingListType.ShippedToDonorCenter) {
            if (props.data.statusId == SerologyTrackingStatus.ShippedOut || props.data.statusId == SerologyTrackingStatus.ShippedBack || props.data.statusId == SerologyTrackingStatus.ShippedRemote) {
                menuItems.push(AdminActions.TrackPackage);
            }

            if (props.data.statusId == SerologyTrackingStatus.ShippedOut || props.data.statusId == SerologyTrackingStatus.ShippedBack) {
                menuItems.push(AdminActions.MarkReceived);
            }

            if (props.data.statusId == SerologyTrackingStatus.Received) {
                menuItems.push(AdminActions.ShipToRemoteDonor);
            }

            if (props.data.statusId == SerologyTrackingStatus.Received || props.data.statusId == SerologyTrackingStatus.ShippedRemote) {
                menuItems.push(AdminActions.SerologyTestsShippedBack);
            }

            menuItems.push(AdminActions.MarkCancelled);
        }

        if (props.listType == SerologyTrackingListType.ShippedBackToVendor) {
            if (props.data.statusId == SerologyTrackingStatus.ShippedOut || props.data.statusId == SerologyTrackingStatus.ShippedBack || props.data.statusId == SerologyTrackingStatus.ShippedRemote) {
                menuItems.push(AdminActions.TrackPackage);
            }

            if (props.data.statusId == SerologyTrackingStatus.ShippedBack) {
                menuItems.push(AdminActions.MarkReceived);
            }

            if (props.data.statusId == SerologyTrackingStatus.ReceivedBack) {
                menuItems.push(AdminActions.ResultsSent);
            }
        }

        menuItems.push(AdminActions.Divider);
        menuItems.push(AdminActions.Delete);

        return menuItems;
    };

    if (props.data == null)
        return null;

    const menuItems = getMenuItems().map(item => {
        return menuItemList.find(x => x.action == item);
    });

    const menu = menuItems.map(item => {
        let url = getUrl(item.action);
        let id = item.action >= 0 ? props.data.id : 'div-' + props.data.id + '-' + Math.random() * 10000;

        if (url == null) {
            if (item.action >= 0) {
                return { id, action: item.action, include: true, selectable: true, element: <>{item.title}</> };
            } else {
                return { id, action: item.action, include: true, selectable: false, element: <div style={{ height: 10 }}></div>, divider: true };
            }
        } else {
            return { id, action: item.action, include: true, selectable: false, element: <a href={url.link} target={url.target}>{item.title}</a> };
        }
    });

    return (
        <OverlayMenuButton
            menu={menu}
            bsStyle='primary'
            bsSize='xs'
            title='Actions'
            listItemStyle={{ padding: '2px 10px', fontSize: 14 }}
            includeCaret={true}
            onToggle={handleMenuToggle}
            onSelect={handleMenuSelection}
        />
    );
}

export default ActionsDropdownAdmin;